<template>
  <div class="wizard-progress">
    <div class="wizard-progress__label">Step {{ current }} of {{ total }}</div>
    <div class="wizard-progress__bar">
      <div class="wizard-progress__fill" :style="{ width: pct + '%' }" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'WizardProgressBar',
  props: {
    current: { type: Number, required: true },
    total:   { type: Number, required: true },
  },
  computed: {
    pct() {
      return Math.round((this.current / this.total) * 100)
    },
  },
}
</script>

<style scoped>
.wizard-progress {
  margin-bottom: 20px;
}
.wizard-progress__label {
  font-size: 0.78rem;
  color: #888;
  margin-bottom: 6px;
  font-weight: 500;
}
.wizard-progress__bar {
  height: 6px;
  background: #e0e0d8;
  border-radius: 3px;
  overflow: hidden;
}
.wizard-progress__fill {
  height: 100%;
  background: #2e7d32;
  border-radius: 3px;
  transition: width 0.3s ease;
}
</style>
